export default __webpack_public_path__ + "static/media/th-list-solid.ac61fcb0.svg";